export default __webpack_public_path__ + "static/shelter-island-c56ca26f30721b48cdf6354b2345b11f.gif";